import React, { Component, PropTypes } from 'react';
import openModal from './openModal';

export default function withOpenC3Modal(WrappedComponent) {
    return class WithOpenC3Modal extends Component {
        static contextTypes = { 
            store: PropTypes.object 
        };
        openc3Modal(ModalComponent, props) {
            var { store } = this.context;
            return openModal(ModalComponent, { store, ...props });
        }
        render() {
            return (
                <WrappedComponent {...this.props} openc3Modal={this.openc3Modal.bind(this)} />
            );
        }
    }
}


// WEBPACK FOOTER //
// ./app/c3/modal/withOpenC3Modal.js